import { Text } from "@clayui/core";
import ClayIcon from "@clayui/icon";
import ClaySticker from "@clayui/sticker";
import React from "react";

const NavigationModuleItem = ({isLessonCompleted, navigationMenuItem}) => {
  return (
    <div
      className={`d-flex px-3 py-3 lesson-link ${
        isLessonCompleted(navigationMenuItem.lesson[0].id)
          ? "completed"
          : "not-completed"
      } ${navigationMenuItem.lesson[0].active ? "active" : ""}`}
    >
      {isLessonCompleted(navigationMenuItem.lesson[0].id) && (
        <ClaySticker shape="circle" displayType="primary" size="md">
          <ClayIcon symbol="check" />
        </ClaySticker>
      )}
      <span className="module-title my-auto px-2">
        <Text size={4} weight={"semi-bold"}>
          <a
            className="lesson-link"
            style={{ textDecoration: "none" }}
            href={`/l/${navigationMenuItem.lesson[0].id}`}
          >
            {navigationMenuItem.lesson[0].title === ""
              ? navigationMenuItem.lesson[0].title_i18n.en_US
              : navigationMenuItem.lesson[0].title}
          </a>
        </Text>
      </span>
    </div>
  );
};

export default NavigationModuleItem;
